let online_payment_form = function( $ ) {

	let $form;

	let _init = function() {
		$form = $( 'form#gform_1' );

		if ( $form.length > 0 ) {
			_init_select2();

			// When the form is re-rendered by gravity forms on submission we need to re-init select2
			$( document ).on( 'gform_post_render', function( event, form_id, current_page ) {
				$form = $( 'form#gform_' + form_id );

				_init_select2();
			});
		}
 	};

	let _init_select2 = function() {
		let $select = $form.find( 'select' );

		$select.select2( {
			dropdownParent: $select.closest( 'span' ), // Parent is span as the selects are within a complex field group
		} );
	};

	$( document ).ready( _init )

} ( jQuery );

module.exports = online_payment_form;